import { helpers } from '@vuelidate/validators';

export const ipV4 = helpers.regex(
    /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
);

export const fileSize50 = (max = 50) => {
    const maxInBytes = max * 1000 * 1000;

    return (value: File) => {
        if (!value) {
            return { $valid: true };
        }
        const file = value;
        const isValid = file.size < maxInBytes;
        return { $valid: isValid, $params: { max: max } };
    };
};

export const mustBeConfirmed = () => {
    return (value) => {
        return { $valid: value === true };
    };
};

export const ALLOWED_ATTACHMENT_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'text/plain',
    'text/csv',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
] as const;

/** Human-readable extensions for validation messages (matches ALLOWED_ATTACHMENT_MIME_TYPES). */
export const ALLOWED_ATTACHMENT_EXTENSIONS =
    'PDF, JPG, PNG, GIF, WebP, TXT, CSV, DOC, DOCX, XLS, XLSX';

export const allowedAttachmentType = () => {
    return (value: File) => {
        if (!value) {
            return { $valid: true };
        }
        const mimeType = value.type?.trim() || '';
        const isValid =
            mimeType.length > 0 &&
            mimeType !== 'application/octet-stream' &&
            (ALLOWED_ATTACHMENT_MIME_TYPES as readonly string[]).includes(mimeType);
        return { $valid: isValid, $params: { extensions: ALLOWED_ATTACHMENT_EXTENSIONS } };
    };
};
